import extractErrorMessage from '../utils/extractErrorMessage';
import { authClient } from './client';

/** Paginated admin action history, newest first. Requires audit:read. */
export const fetchAuditLogs = async ({
  page = 1,
  limit = 20,
  search = '',
  actorId,
  entityType,
  method,
  from,
  to,
} = {}) => {
  try {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    });
    if (search) params.append('search', search);
    if (actorId) params.append('actorId', actorId);
    if (entityType) params.append('entityType', entityType);
    if (method) params.append('method', method);
    if (from) params.append('from', from);
    if (to) params.append('to', to);
    const response = await authClient.get(
      `/admin/audit-logs?${params.toString()}`
    );
    return { data: response.data.data, error: null };
  } catch (error) {
    return {
      data: null,
      error: extractErrorMessage(
        error,
        'Došlo je do greške pri dobavljanju istorije akcija.'
      ),
    };
  }
};

/** Entity types present in the log, as [{ value, label }]. Requires audit:read. */
export const fetchAuditEntityTypes = async () => {
  try {
    const response = await authClient.get('/admin/audit-logs/entity-types');
    return { data: response.data.data, error: null };
  } catch (error) {
    return {
      data: null,
      error: extractErrorMessage(
        error,
        'Došlo je do greške pri dobavljanju tipova entiteta.'
      ),
    };
  }
};
